// extracted by mini-css-extract-plugin
export default {"signInPage":"SignIn_signInPage__eY6c+"};